export default __webpack_public_path__ + "static/egan-7f8f0ef519422f0d7276361e5e00eb9b.png";